// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthHeaderDayName_root__2DlA4","isToday":"MonthHeaderDayName_isToday__2ZaVY"};